export const languages = [
  { name: "Python", level: 82 },
  { name: "C", level: 70 },
  { name: "C++", level: 90 },
  { name: "JavaScript", level: 80 },
  { name: "SQL", level: 75 },
];

export const tools = [
  { n: "Git", c: "green" },
  { n: "GitHub", c: "green" },
  { n: "VS Code", c: "cyan" },
  { n: "Jupyter", c: "orange" },
];

export const cloud = [
  { n: "Firebase", c: "orange" },
  { n: "Cloudinary", c: "purple" },
  { n: "Vercel", c: "cyan" },
  { n: "Render", c: "green" },
];

export const frontend = [
  { name: "React.js", level: 82 },
  { name: "Tailwind CSS", level: 80 },
  { name: "HTML / CSS", level: 88 },
];

export const backend = [
  { name: "Node.js", level: 75 },
  { name: "Express", level: 72 },
  { name: "FAST API", level: 70 },
];

export const mlTools = [
  { n: "NumPy", c: "pink" },
  { n: "Pandas", c: "pink" },
  { n: "Scikit-learn", c: "purple" },
  { n: "Matplotlib", c: "purple" },
];

export const databases = [
  { n: "MySQL", c: "orange" },
  { n: "MongoDB", c: "green" },
  { n: "Firebase", c: "orange" },
];
